import React, { useEffect } from "react";

import { useFormContext } from "react-hook-form";

import { Select } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";
import { cannotHappen } from "@app/utils/cannot-happen";

import { useRegionDetails } from "./use-region-details";

export const StateField: React.FC<{ className?: string }> = ({ className }) => {
  const { geoData, translator } = useAppContext();
  const {
    register,
    watch,
    setValue,
    reset,
    formState: { defaultValues, errors }
  } = useFormContext();
  const [region_type, region_options] = useRegionDetails(watch("country_code"));
  const zip_code = watch("zip_code");
  const country_code = watch("country_code");

  useEffect(() => {
    const region = geoData.getRegionCodeFromPostalCode(country_code, zip_code);

    if (region && watch("state") !== region) {
      setValue("state", region, {
        shouldDirty: true,
        shouldValidate: true
      });
      reset({ state: region });
    }
  }, [zip_code, country_code, geoData, watch, setValue, reset]);

  if (region_type === null) {
    return null;
  }

  let label: string | undefined;
  if (region_type === "province") {
    label = translator.t("!checkout.payment.state:province");
  } else if (region_type === "state") {
    label = translator.t("!checkout.payment.state:state");
  } else {
    cannotHappen(region_type, "Unknown region type");
  }

  return (
    <Select
      className={className}
      labelText={label}
      id="state"
      data-has-error={errors.state}
      isInvalid={!!errors.state}
      defaultValue={defaultValues?.state}
      data-testid="state"
      {...register("state")}
    >
      {region_options.map(({ value, label }) => (
        <Select.Option key={value} value={value}>
          {label}
        </Select.Option>
      ))}
    </Select>
  );
};
